export const BANK_DECISION_MADE = 'BANK_DECISION_MADE';

export const bankDecisionMade = payload => dispatch =>
  dispatch({
    type: BANK_DECISION_MADE,
    payload,
  });
